import React, { useState } from "react";
//icons
import { BsGraphUp, BsThreeDotsVertical } from "react-icons/bs";
import { FaEdit } from "react-icons/fa";
import { FcSurvey } from "react-icons/fc";
import { IoMdEye } from "react-icons/io";
import { MdCopyAll } from "react-icons/md";

import Fade from "@mui/material/Fade";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useMutation } from "@tanstack/react-query";
import {
  AiFillCheckSquare,
  AiFillCloseSquare,
  AiFillDelete,
} from "react-icons/ai";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { deleteSurvey } from "../../services/ApiServices";


import CustomTooltip from "../Tooltip/CustomTooltip";

export default function SurverItems({ title, description, id, refetch }) {
  const history = useHistory();

  const [DeleteMenü, setDeleteMenü] = useState(false);

  function CopyLink() {
    handleClose();
    toast.info("Anket ID'si panoya kopyalanadı.");
    navigator.clipboard.writeText(id);
  }

  const mutation = useMutation(deleteSurvey, {
    onSuccess: (value) => {
      toast.success(title + " isimli anket başarı bir şekilde silinmiştir.");
      refetch();
    },
  });

  function DeleteSurvey(id) {
    mutation.mutate(id);
    setTimeout(() => {
      setDeleteMenü(false);
    }, 100);
  }

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [visiblty, setvisiblty] = useState(false);
  return (
    <>
      <div
        onMouseOver={() => setvisiblty(true)}
        onMouseLeave={() => (setvisiblty(false), setDeleteMenü(false))}
        className="transition-all md:h-[203px] max-w-sm md:w-full relative  flex flex-col items-center rounded-bottom overflow-hidden  shadow-xl border-t-2  border-blue-500 m-3   "
      >
        {!DeleteMenü ? (
          <div
            className={
              visiblty
                ? "  hidden md:flex items-center justify-center  opacity-100 absolute  bg-blue-500 w-full h-12 p-1 transition-all "
                : "hidden md:flex transition-all h-0 opacity-0  bg-blue-500 w-full absolute  items-center justify-center "
            }
          >
            <div className=" bg-white p-1 text-sm rounded-sm font-bold px-2">
              {id}
            </div>
            <CustomTooltip
              placement="top"
              title="Anketin anaharının kopyalanmasını sağlar."
            >
              <div className="m-2 ml-4">
                <MdCopyAll
                  onClick={() => CopyLink()}
                  size={25}
                  className="cursor-pointer hover:text-white text-white"
                />
              </div>
            </CustomTooltip>

            <div className=" flex items-end justify-end xl:ml-3 lg:ml-32md:ml-1 ml-2">
              <CustomTooltip
                placement="top"
                title="Anketin yeni sayfada açılmasını sağlar."
              >
                <a
                  className="m-1 "
                  style={{ display: "table-cell" }}
                  target="_blank"
                  href={process.env.REACT_APP_FRONT_URL + "/survey/" + id}
                >
                  <IoMdEye
                    size={25}
                    className="cursor-pointer hover:text-white text-white"
                  />
                </a>
              </CustomTooltip>

              <CustomTooltip placement="top" title="Anketi Silmenizi sağlar.">
                <div className="m-1">
                  <AiFillDelete
                    onClick={() => setDeleteMenü(true)}
                    size={25}
                    className="cursor-pointer hover:text-white text-white "
                  />
                </div>
              </CustomTooltip>
            </div>
          </div>
        ) : (
          <div
            className={
              visiblty
                ? "  hidden md:flex items-center justify-center  opacity-100 absolute  bg-blue-500 w-full h-12 p-1 transition-all "
                : "hidden md:flex transition-all h-0 opacity-0  bg-blue-500 w-full absolute  items-center justify-center "
            }
          >
            <div className="text-white">
              silmek istediğinizden emin misiniz?
            </div>
            <AiFillCheckSquare
              onClick={() => DeleteSurvey(id)}
              className="text-white text-[28px] m-1 ml-4 cursor-pointer hover:text-gray-200"
            />
            <AiFillCloseSquare
              onClick={() => setDeleteMenü(false)}
              className="text-white text-[28px] m-1 cursor-pointer hover:text-gray-200"
            />
          </div>
        )}

        <div
          className={
            visiblty
              ? "flex  cursor-pointer md:mt-10 mt-4 transition-all"
              : "flex  cursor-pointer mt-4 transition-all"
          }
        >
          <a
            target="_blank"
            href={process.env.REACT_APP_FRONT_URL + "/survey/" + id}
            className="flex justify-center  items-center text-center  bg-white rounded-2xl   p-1 m-1  "
          >
            <FcSurvey size={80} />
          </a>
          <div>
            <div className=" mt-1 ">
              <div className="font-bold text-xl mb-2 flex w-full justify-center items-center">
                <a
                  target="_blank"
                  href={process.env.REACT_APP_FRONT_URL + "/survey/" + id}
                  className="flex flex-1 w-12 text-[16px]   m-2 mb-0 line-clamp-1 overflow-hidden"
                >
                  {title}
                </a>

                <div className="flex   flex-1 justify-end items-end md:hidden  m-2 ">
                  <BsThreeDotsVertical onClick={handleClick} />
                </div>
              </div>
              <a
                target="_blank"
                href={process.env.REACT_APP_FRONT_URL + "/survey/" + id}
                className="text-black/70 text-sm  h-16   w-48 m-2 mt-0 line-clamp-3 overflow-hidden"
              >
                {!!description
                  ? description
                  : "Bu anketin açıklaması eklenmemiş. Açıklama eklemek için düzenleyiniz."}
              </a>
            </div>
          </div>
        </div>

        <div className="hidden md:inline w-full">
          <div className="flex w-full  ">
            <CustomTooltip
              title={
                "Anket sonuçlarına göre oluşan grafiklerin sayfasını açar."
              }
            >
              <div
                onClick={() => history.push("/analysis/" + id)}
                className="flex flex-1 py-1   bg-gray-200  justify-center items-center cursor-pointer hover:bg-gray-400 "
              >
                <BsGraphUp className="m-2 " />
                <div>Grafikler</div>
              </div>
            </CustomTooltip>

            <CustomTooltip title={"Anketi düzenlemenizi sağlar"}>
              <div
                onClick={() => history.push("/editsurvey/" + id)}
                className="flex  flex-1  py-1  bg-gray-200  justify-center items-center cursor-pointer hover:bg-gray-400 "
              >
                <FaEdit className="m-2 " />
                <div>Düzenle</div>
              </div>
            </CustomTooltip>
          </div>
        </div>

        <Menu
          id="fade-menu"
          MenuListProps={{
            "aria-labelledby": "fade-button",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
        >
          <MenuItem onClick={() => history.push("/analysis/" + id)}>
            Grafikler
          </MenuItem>
          <MenuItem onClick={handleClose}>Düzenle</MenuItem>
          <MenuItem onClick={() => CopyLink()}>Anahtarı Kopyala</MenuItem>
          <MenuItem onClick={handleClose}>
            <a
              style={{ display: "table-cell" }}
              target="_blank"
              href={process.env.REACT_APP_FRONT_URL + "/survey/" + id}
            >
              Anketi Aç
            </a>
          </MenuItem>
        </Menu>
      </div>
    </>
  );
}
